import { useCallback } from 'react';

import { useRouter } from '~/hooks/useRouter';
import { colors } from '~/theme/colors';

export const useMenuListController = () => {
  const { location, goToRoute } = useRouter();

  const isActiveMenu = useCallback(
    (pathName: string) => {
      return pathName === '/'
        ? pathName === location.pathname
        : location.pathname.includes(pathName);
    },
    [location.pathname],
  );

  const getStyles = useCallback(
    (pathName: string) => {
      return {
        text: isActiveMenu(pathName) ? 'primary.600' : 'gray.600',
        icon: isActiveMenu(pathName) ? colors.primary[600] : colors.gray[600],
        bgColor: isActiveMenu(pathName) ? 'primary.50' : '',
      };
    },
    [isActiveMenu],
  );

  return {
    goToRoute,
    getStyles,
  };
};
